import React, { Component } from 'react'

import {
    FormControl,
    FormGroup,
    FormControlLabel,
    Checkbox,
    Select,
    MenuItem,
} from '@mui/material'

import {
    FormInputLabel,
    selectionControlLabelProps,
    selectionControlSx,
} from '@/shared/ui/input'
class DefFieldDateSettings extends Component {
    constructor(props) {
        super(props)
        this.state = {
            current_time_as_default:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.current_time_as_default
                    ? this.props.item.settings.current_time_as_default
                    : null,
            restriction:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.restriction
                    ? this.props.item.settings.restriction
                    : 'none',
            restrict_days:
                this.props.item &&
                this.props.item.settings &&
                this.props.item.settings.restrict_days &&
                Array.isArray(this.props.item.settings.restrict_days)
                    ? this.props.item.settings.restrict_days
                    : [],
        }

        this.onChange = this.onChange.bind(this)
        this.onChangeDay = this.onChangeDay.bind(this)
    }

    onChange(event) {
        const { name, value, checked, type } = event.target
        const nextValue = type === 'checkbox' ? checked : value

        this.props.onChange(name, nextValue)
        this.setState({ [name]: nextValue })
    }

    onChangeDay(e) {
        let days = this.state.restrict_days
        days = days.filter((item) => item !== e.target.value)
        if (e.target.checked) {
            days.push(e.target.value)
        }

        this.props.onChange(e.target.name, days)
        this.setState({ restrict_days: days })
    }

    render() {
        const { kedo } = this.props
        const { current_time_as_default, restriction, restrict_days } =
            this.state
        const days = [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
        ]

        return (
            <div>
                <h3>{this.props.kedo.t('Settings')}</h3>
                <FormControl fullWidth margin="normal">
                    <FormControlLabel
                        {...selectionControlLabelProps}
                        control={
                            <Checkbox
                                checked={current_time_as_default}
                                onChange={this.onChange}
                                name="current_time_as_default"
                                size="small"
                                sx={selectionControlSx}
                            />
                        }
                        label={kedo.t('Use current date/time as default value')}
                    />
                </FormControl>
                <hr />
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {kedo.t('Restrict calendar selection')}
                    </FormInputLabel>
                    <Select
                        value={restriction || 'none'}
                        onChange={this.onChange}
                        name="restriction"
                        fullWidth
                        size="small"
                    >
                        <MenuItem value="none">{kedo.t('None')}</MenuItem>
                        <MenuItem value="before_and_eq_current_date">
                            {kedo.t('Before and equal to the current date')}
                        </MenuItem>
                        <MenuItem value="after_and_eq_current_date">
                            {kedo.t('After and equal to the current date')}
                        </MenuItem>
                    </Select>
                </FormControl>
                <hr />
                <FormControl fullWidth margin="normal">
                    <FormInputLabel>
                        {kedo.t('Only allow selected days')}
                    </FormInputLabel>
                    <FormGroup>
                        {days.map((day, index) => (
                            <FormControlLabel
                                key={index}
                                {...selectionControlLabelProps}
                                control={
                                    <Checkbox
                                        checked={restrict_days.includes(
                                            index.toString()
                                        )}
                                        onChange={this.onChangeDay}
                                        name="restrict_days"
                                        value={index.toString()}
                                        size="small"
                                        sx={selectionControlSx}
                                    />
                                }
                                label={kedo.t(`days_full.${day}`)}
                            />
                        ))}
                    </FormGroup>
                </FormControl>
            </div>
        )
    }
}

export default DefFieldDateSettings
